<template>
    <div id="app">
      <div class="container-fluid">
        <div class="row">
          <SideBar class="col-md-3" />
          <LogedHeader class="col-md-9"/>
        </div>
      </div>
      <router-view/>
    </div>
</template>

<script>
  import LogedHeader from './components/LogedHeader.vue';
  import SideBar from './components/SideBar.vue';
  import bg from './lang/bg_BG.js';
  import en from './lang/en_EN.js';
  import us from './lang/us_US.js';

  export default {
    name: 'app',
    components: {
      LogedHeader,
      SideBar
    },
    data(){
      return{
        user: [],
        doctor:[],
        lastActive : null,
        doctorLastActive: null
      }
    },
    watch: {
      $route (to, from){
        this.watchUserTime();
        this.watchDoctorTime();
      }
    },
    created(){
      if (this.$route.params.lang == 'en') {
        localStorage.setItem('language','en_EN')
        this.$bus.$emit('language',true)
        window.message = en;
        window.lang = 'en';
      }else if(this.$route.params.lang == 'bg'){
        localStorage.setItem('language','bg_BG')
        this.$bus.$emit('language',true)
        window.message = bg;
        window.lang = 'bg';
      }else if(this.$route.params.lang == 'us'){
        localStorage.setItem('language','us_US')
        this.$bus.$emit('language',true)
        window.message = us;
        window.lang = 'us';
      }else{
        localStorage.setItem('language','bg_BG')
        this.$bus.$emit('language',true)
        window.message = bg;
        window.lang = 'bg';
      }
      this.setLanguage();
      this.$bus.$on('language', () => {
        this.setLanguage();
      });
      this.getUser();
      this.getDoctor();
      axios.get('get-last-active')
      .then(function(response){
        if (response.result != null) {
          if (response.data.result.lastActive) {
            self.lastActive = response.data.result.lastActive;
          }
        }
      })
      axios.get('get-doctor-last-active')
      .then(function(response){
        if (response.result !=null) {
          if (response.data.result.lastActive) {
            self.doctorLastActive = response.data.result.lastActive;
          }
        }
      })
      if (this.$route.path == '/' && this.$route.params.lang !== 'en' && this.$route.params.lang !== 'bg') {
        this.$router.push(window.lang + this.$route.path)
      }
      console.log('#Page app');
    },
    methods: {
      setLanguage: function(){
        if (localStorage.getItem('language') == 'en_EN') {
          window.message = en;
          window.lang = 'en';
        }else if(localStorage.getItem('language') == 'us_US'){
          localStorage.setItem('language','us_US')
          window.message = us;
          window.lang = 'us';
        }else if(localStorage.getItem('language') == 'bg_BG'){
          localStorage.setItem('language','bg_BG')
          window.message = bg;
          window.lang = 'bg';
        }
      },
      getUser: function(){
        this.loader = true;
        var self = this;
        axios.get('get-user')
        .then(function (response){
            self.loader = false;
            self.user = null;
            if(response.data.result){
              self.user = response.data.result;
            }
            if (self.user || self.user.lenght) {
              if (self.user.userLoggedIn) {
                localStorage.setItem('userLoggedIn', response.data.result.userLoggedIn);
                self.$bus.$emit('sideBar', true);
                if (response.data.result.userLanguage) {
                  localStorage.setItem('language', response.data.result.userLanguage);
                  self.$bus.$emit('language',true)
                }
                if (self.$route.name == 'home') {
                  self.$router.push({ name: 'user-home-page', params: { lang: window.lang } })
                }
              }else {
                localStorage.removeItem('userLoggedIn');
              }
            }
        })
        .catch(err => console.error(err))
      },
      getDoctor: function(){
        this.loader = true;
        var self = this;
        axios.get('get-doctor')
        .then(function (response){
            self.loader = false;
            self.doctor = null;
            if(response.data.result){
              self.doctor = response.data.result;
            }
            if (self.doctor || self.doctor.lenght) {
              if (self.doctor.doctorLoggedIn) {
                localStorage.setItem('doctorLoggedIn', response.data.result.doctorLoggedIn);
                self.$bus.$emit('sideBar', true)
                if (response.data.result.doctorLanguage) {
                  localStorage.setItem('language', response.data.result.doctorLanguage);
                  self.$bus.$emit('language',true)
                }
                if (self.$route.name == 'home') {
                  self.$router.push({ name: 'doctor-home', params: { lang: window.lang } })
                }
              }else {
                localStorage.removeItem('doctorLoggedIn');
              }
            }
        })
        .catch(err => console.error(err))
      },
      watchUserTime(){
        var self = this;
        axios.get('get-last-active')
        .then(function(response){
          if (response.result != null || response.data.result) {
            self.lastActive = response.data.result.lastActive;
          }
        })
        const time = new Date().getTime();
        const dbTime = new Date(Number((this.lastActive))).getTime() + 3600000;
        if (this.lastActive) {
          if (dbTime > time) {
            var formData = this.toFormData({lastActive:time})
            axios.post('check-last-active',formData)
            .then(function(){

            })
          }else {
            // self.$router.push('/logout')
            // this.lastActive = null;
          }
        }
      },
      watchDoctorTime(){
        var self = this;
        axios.get('get-doctor-last-active')
        .then(function(response){
          if (response.result != null || response.data.result) {
            self.doctorLastActive = response.data.result.lastActive;
          }
        })
        const time = new Date().getTime();
        const dbTime = new Date(Number((this.doctorLastActive))).getTime() + 3600000;
        if (this.doctorLastActive) {
          if (dbTime > time) {
            var formData = this.toFormData({lastActive:time})
            axios.post('check-doctor-last-active',formData)
            .then(function(){
            })
          }else {
            // self.$router.push('/doctor-logout')
            // this.doctorLastActive = null;
          }
        }
      },
      toFormData: function (obj){
        var form_data = new FormData();
        for (var key in obj) {
          form_data.append(key,obj[key]);
        }
        return form_data;
      }
    }
  }

</script>

<style>
* {
  box-sizing: border-box;
}
@font-face {
  font-family: 'Raleway-Medium';
  src: url("./assets/fonts/Raleway-Medium.woff") format("woff");
  font-display: swap;
}
.container-fluid, .row{
  padding: 0;
  margin: 0;
}
.loader {
    position: fixed;
    left: 0px;
    top: 0px;
    width: 100%;
    height: 100%;
    z-index: 9999;
    background: url('./assets/loading.svg') 50% 50% no-repeat rgb(249,249,249);
    opacity: .8;
}
/* new css */
body,html{
  height: 100vh;
  font-size: 20px;
}
#app {
  font-family: 'Raleway-Medium', sans-serif;
  text-align: center;
  color: #2c3e50;
}
#app button{
  font-size: 20px;
}
#app img{
  display: inline-block;
}
#app a:hover{
  text-decoration: none;
}
input, textarea {
  background: none;
  border: none;
  outline: none;
  border-bottom: 2px solid #FFF;
  width: 100%;
}
#loged-home .user img{
  width: 2em;
  display: inline-block;
}
.list-group-item{
  border: none;
  background: none;
  padding-left: 0;
  font-size: .8em;
}

@font-face {
  font-family: 'Montserrat-Black';
  src: url("./assets/fonts/Montserrat-Black.woff") format("woff");
  font-display: swap;
}
h3,h4{
  font-family: 'Montserrat-Black', sans-serif;
  margin-bottom: 2em;
}
h3 a {
  margin-right: 1em;
}
h3 a:hover {
  cursor: pointer;
}
.sidebar{
  position: relative;
  padding: 0;
}
.sidebar div{
  background-repeat:no-repeat;
  background-size:100% inherit;
  background-position:center;
  position: fixed;
  width:inherit;
  max-width:inherit;
  max-height: 100%;
  top: 0;
  bottom: 0;
  left: 0;
  z-index: 999;
  padding-left: 0;
}
#loged-home {
  position: fixed;
  top: 0;
  right: 0;
  height: 65px;
  z-index: 999;
  background-color: #fff;
  padding: 15px;
}

#registration .card,
#login .card,
#reset .card-conteiner{
  width: 90%;
  background: #fff;
  outline: none!important;
  margin: 0 auto;
  -webkit-box-shadow: 0 0 5px 10px rgba(168,168,168,.1);
  -moz-box-shadow: 0 0 5px 10px rgba(168,168,168,.1);
  box-shadow: 0 0 5px 10px rgba(168,168,168,.1);
  border-radius: .75em
}
#app *{
  outline: none!important;
}
#registration .card .tab-content,
#login .card .tab-content,
#reset .card-conteiner .tab-content{
  outline: none!important;
}
#reset .card-conteiner{
  -webkit-box-flex: 1;
  flex: 1 1 auto;
  padding: 1.25rem;
  background-color: #FFF;
  margin-bottom: 1em;
}
.modal {
  display: block; /* Hidden by default */
  position: fixed; /* Stay in place */
  z-index: 99999; /* Sit on top */
  left: 0;
  top: 0;
  width: 100%; /* Full width */
  height: 100%; /* Full height */
  overflow: auto; /* Enable scroll if needed */
  background-color: rgb(0,0,0); /* Fallback color */
  background-color: rgba(0,0,0,0.6); /* Black w/ opacity */
}
.modal-content .modal-header{
  border-bottom: 1px solid #707070;
}
.modal-body{
  margin: 1em;
  min-height: 33em;
}
.modal-body-small{
  min-height: 5em;
}
/* Modal Content/Box */
.modal-content {
  margin: 5% auto; /* 15% from the top and centered */
  border: 1px solid #888;
  width: 60%; /* Could be more or less, depending on screen size */
  background: #EEEEEE;
  border-radius: 2em;
}
.modal-small{
  width: 30%;
}
.modal-footer{
  background: #3057B0;
  padding: 2em;
  border-bottom-left-radius: 2em;
  border-bottom-right-radius: 2em;
}
/* The Close Button */
.close-modal {
  color: #707070;
  float: right;
  font-size: 3em;
  font-weight: 100;
}

.close-modal:hover,
.close-modal:focus {
  color: black;
  text-decoration: none;
  cursor: pointer;
}
.close-modal-button {
  padding: .5em;
  padding-left: .5em;
  padding-right: .5em;
  background-color: #3057B0;
  border: 2px solid #fff;
  border-radius: 5em;
  color: #fff;
  font-weight: bold;
}
.modal-button-add{
  padding: .5em;
  padding-left: 1em;
  padding-right: 1em;
  background-color: #fff;
  border: 2px solid #fff;
  border-radius: 5em;
  color: #3057B0;
  font-weight: bold;
}
.modal-button-remove {
  margin-left: 1em;
}

.close-modal-button:hover {
  padding: .5em;
  padding-left: .5em;
  padding-right: .5em;
  background-color: #3057B0;
  border: 2px solid #fff;
  border-radius: 5em;
  color: #fff;
  font-weight: bold;
}
@font-face {
  font-family: 'Montserrat-Black';
  src: url("./assets/fonts/Montserrat-Black.woff") format("woff");
  font-display: swap;
}
.modal h3{
  margin-top: 1em;
  text-align: left;
  font-family: 'Montserrat-Black', sans-serif;
  margin-bottom: 2em;
  color: #3057B0;
  display: inline-block;
}
#reset .card-conteiner p{
  margin-top: 3em;
  margin-bottom: 2em;
}
.tabs .nav {
  display: block;
}
@media (max-width: 1590px) {
  body,html{
    font-size: 16px;
  }
  #app button{
    font-size: 16px;
  }
}

@media (max-width: 768px) {
  #app{
    font-size: 1em;
  }
  #registration .card,
  #login .card,
  #reset .card-conteiner{
    width: 100%;
  }
  .search-vet-button{
    position: relative;
  }
  .btn{
    font-size: .75em;
  }
  #registration .card,
  #login .card,
  #reset .card-conteiner{
    width: 100%;
  }
  .sidebar div{
    position: relative;
  }
  h3,h4 {
    margin-bottom: 1em;
  }
  input, textarea{
    margin-bottom: 2em;
  }
  input:focus + label,
  textarea:focus + label{
     bottom: 4em;
  }
  textarea:focus + label{
    bottom: 5em;
    left: 1em;
  }
  .modal-small,.modal-content {
    width: 90%;
  }
 }

</style>
